// extracted by mini-css-extract-plugin
export default {"container":"FocusModeModal_container__g+Krk","message":"FocusModeModal_message__QqtiQ","action":"FocusModeModal_action__pM1lL","likeAnimation":"FocusModeModal_likeAnimation__fOvsH"};